
import React from 'react';
import { dollarToString } from "../../../lib/currency-utils";

const priceFontSize = "1.6rem";

const render_price = (cents, rightPadding, style_override = {}) => {
  const spanStyle = {
    fontSize: priceFontSize,
    paddingRight: rightPadding,
    ...style_override,
  };
  if (cents < 0) {
    spanStyle.color = "#F00";
  }

  if (typeof cents === "number") {
    return (<span style={spanStyle}>{dollarToString(cents)}</span>);
  } else if (typeof cents === "string") {
    return (<span style={spanStyle}>{cents}</span>);
  }
};

const render_price_2 = cents => {
  let color = "#000";
  if (cents > 0) {
    color = "#008040";
  } else if (cents < 0) {
    color = "#F00";
  }
  const style = {
    color
  };
  return (<span style={style}>{dollarToString(cents)}</span>);
};

export { render_price, render_price_2 };
